var chunkMapping = {
	"60": [
		1060
	],
	"386": [
		9386
	],
	"391": [
		1391
	],
	"749": [
		749
	],
	"922": [
		5922
	],
	"959": [
		3959
	]
};
var idToExternalAndNameMapping = {
	"749": [
		"default",
		"./clearCartBtn",
		1493
	],
	"1060": [
		"default",
		"./cartItems",
		1493
	],
	"1391": [
		"default",
		"./keepShoppingBtn",
		1493
	],
	"3959": [
		"default",
		"./quickOrderBtn",
		1493
	],
	"5922": [
		"default",
		"./orderSummary",
		1493
	],
	"9386": [
		"default",
		"./orderDetailsForm",
		1493
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}